/**
 * FarmPacks: the magnifier in the header shows and hides the search bar.
 *
 * The bar is hidden until asked for, on phones and desktop alike (CSS keys off
 * data-fp-search-open on #header-component). On a search results page, or with
 * text already in the box, it starts open. Escape closes it.
 */
(() => {
  const OPEN = 'data-fp-search-open';

  const header = () => document.getElementById('header-component');
  const input = () => document.getElementById('fp-header-search-input');

  function set(open, focus) {
    const host = header();
    if (!host) return;
    host.toggleAttribute(OPEN, open);
    document.querySelectorAll('[data-fp-search-toggle]').forEach((button) => {
      button.setAttribute('aria-expanded', String(open));
    });
    if (open && focus) input()?.focus();
  }

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-fp-search-toggle]')) return;
    set(!header()?.hasAttribute(OPEN), true);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !header()?.hasAttribute(OPEN)) return;
    if (document.activeElement === input() || document.activeElement?.closest('[data-fp-search-toggle]')) {
      set(false, false);
    }
  });

  const start = () => {
    if (input() && input().value.trim() !== '') set(true, false);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
